<h1 mat-dialog-title>Excel importieren</h1>

<div mat-dialog-content>
    <div class="one-row">
        <input type="file" style="display: none" #fileSelector (change)="handleFile($event)" accept=".xls, .xlsx" />
        <button mat-stroked-button color="accent" (click)="openFileSelector()">
            <mat-icon>attach_file</mat-icon>
            Datei ausw&auml;hlen
        </button>
        <div *ngIf="file">
            <mat-icon style="color: gray">description</mat-icon>
            <span>{{ file.name }}</span>
        </div>
    </div>
    <h4>Spalten auswählen</h4>
    <div class="one-row">
        <div style="width: 100%">
            <div class="one-row">
                <mat-form-field style="width: 48%">
                    <mat-label>Name</mat-label>
                    <mat-select [(value)]="nameColumn">
                        <mat-option *ngFor="let column of columnOptions" [value]="column">
                            Spalte {{ column }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
                <mat-form-field style="width: 48%">
                    <mat-label>Interne Nummer</mat-label>
                    <mat-select [(value)]="kundennummerColumn">
                        <mat-option [value]="null">Spalte Abwählen</mat-option>
                        <mat-option *ngFor="let column of columnOptions" [value]="column">
                            Spalte {{ column }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <div class="one-row">
                <mat-form-field style="width: 48%">
                    <mat-label>Postleitzahl</mat-label>
                    <mat-select [(value)]="plzColumn">
                        <mat-option *ngFor="let column of columnOptions" [value]="column">
                            Spalte {{ column }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
                <span class="spacer"></span>
                <mat-form-field style="width: 48%">
                    <mat-label>Wohnort</mat-label>
                    <mat-select [(value)]="ortColumn">
                        <mat-option *ngFor="let column of columnOptions" [value]="column">
                            Spalte {{ column }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>

            <mat-form-field style="width: 100%">
                <mat-label>Straße</mat-label>
                <mat-select [(value)]="strasseColumn">
                    <mat-option *ngFor="let column of columnOptions" [value]="column"> Spalte {{ column }} </mat-option>
                </mat-select>
            </mat-form-field>

            <div class="one-row">
                <mat-form-field style="width: 48%">
                    <mat-label>Telefon</mat-label>
                    <mat-select [(value)]="phoneColumn">
                        <mat-option [value]="null">Spalte Abwählen</mat-option>
                        <mat-option *ngFor="let column of columnOptions" [value]="column">
                            Spalte {{ column }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
                <span class="spacer"></span>
                <mat-form-field style="width: 48%">
                    <mat-label>Mobil</mat-label>
                    <mat-select [(value)]="mobilColumn">
                        <mat-option [value]="null">Spalte Abwählen</mat-option>
                        <mat-option *ngFor="let column of columnOptions" [value]="column">
                            Spalte {{ column }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <mat-form-field style="width: 100%">
                <mat-label>E-Mail</mat-label>
                <mat-select [(value)]="mailColumn">
                    <mat-option [value]="null">Spalte Abwählen</mat-option>
                    <mat-option *ngFor="let column of columnOptions" [value]="column"> Spalte {{ column }} </mat-option>
                </mat-select>
            </mat-form-field>
            <mat-form-field style="width: 100%">
                <mat-label>Kommentar</mat-label>
                <mat-select [(value)]="kommentarColumn">
                    <mat-option [value]="null">Spalte Abwählen</mat-option>
                    <mat-option *ngFor="let column of columnOptions" [value]="column"> Spalte {{ column }} </mat-option>
                </mat-select>
            </mat-form-field>
        </div>
    </div>
</div>
<div align="end" mat-dialog-actions>
    <button (click)="dialogRef.close()" mat-button>Abbrechen</button>
    <button *kienePermission="[7002]" [disabled]="isDisabled()" (click)="check()" color="primary" mat-flat-button>
        Prüfen
    </button>
</div>
